// material-ui
import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";

// project import
import Avatar from "components/@extended/Avatar";
import { PopupTransition } from "components/@extended/Transitions";
import { FormattedMessage, useIntl } from "react-intl";
//import { deleteCustomer } from 'api/customer';
import { openSnackbar } from "api/snackbar";

// assets
import { DeleteFilled } from "@ant-design/icons";

// types
import { SnackbarProps } from "types/snackbar";
import { useAppDispatch } from "hooks";
import { deleteQuestion } from "store/actions/main/basicInfo/question";
import { useState } from "react";
import { CircularProgress } from "@mui/material";

interface Props {
  id: number;
  title: any;
  open: boolean;
  handleClose?: () => void;
  fetchData?: any;
  setOpen: any;
}

// ==============================|| QUESTION - DELETE ||============================== //

export default function AlertQuestionDelete({
  id,
  title,
  open,
  handleClose,
  fetchData,
  setOpen,
}: Props) {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDelete = () => {
    setIsLoading(true);
    dispatch(deleteQuestion({ id: id })).then((action) => {
      setIsLoading(false);
      fetchData();
      if (action.type === "basicInfo/deletQuestion/fulfilled") {
        openSnackbar({
          open: true,
          message: "Question deleted successfully",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          alert: {
            color: "success",
          },
        } as SnackbarProps);
      } else {
        setIsLoading(false);

        openSnackbar({
          open: true,
          message: action.payload.status,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "alert",
          close: false,
          alert: {
            color: "error",
          },
        } as SnackbarProps);
      }

      setOpen(false);
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="column-delete-title"
      aria-describedby="column-delete-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar
            color="error"
            sx={{ width: 72, height: 72, fontSize: "1.75rem" }}
          >
            <DeleteFilled />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
               <FormattedMessage id="Are you sure you want to delete" />
            </Typography>
            { <Typography align="center">
              <FormattedMessage id="By deleting" />
              <Typography variant="subtitle1" component="span">
                {" "}
                "{title}"{" "}
              </Typography>
                <FormattedMessage id="all data assigned to that category will also be deleted" />
            </Typography> }
          </Stack>
          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button
              fullWidth
              onClick={handleClose}
              color="secondary"
              variant="outlined"
            >
              <FormattedMessage id="Cancel" />
            </Button>
            <Button
              fullWidth
              color="error"
              variant="contained"
              onClick={handleDelete}
              autoFocus
            >
              {isLoading ? (
                <CircularProgress size="1rem" color="inherit" />
              ) : <FormattedMessage id="Delete" />}
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
